<template>
  <div class="case-box">
    <back @change="back"/>
    <!--    搜索框-->
    <search-header @change="searchTitle"/>
    <!--    搜索条件-->
    <search-sifting @change="siftingChange"/>
    <!--    搜索标签-->
    <search-tab keyT="case" @change="tabChange"/>
    <!--  内容  -->
    <case-list :data="contentList"/>

    <footer-number/>
    <!--    空状态-->
    <van-empty
        v-if="searchEmpty && contentList.length < 1"
        class="custom-image"
        :image="searchNull"
    />
  </div>
</template>

<script>
import SearchHeader from "@/views/search/SearchHeader";
import SearchSifting from "@/views/search/SearchSifting";
import SearchTab from "@/views/search/SearchTab";
import CaseList from "@/views/case/CaseList";
import Back from "@/components/back/Back";
import {wxShare} from "@/common/js/wx";
import FooterNumber from '@/components/footer/footerNumber'
import SearchNull from '../../assets/search/search-null.png'


export default {
  name: "case",
  components: {FooterNumber, Back, CaseList, SearchTab, SearchSifting, SearchHeader},
  data() {
    return {
      searchNull: SearchNull,
      searchEmpty: false,
      activityType: this.$route.params.activity,
      search: {
        title: null,
        tag: null,
        sort: null,
        label2: null,
        label3: null,
      },
      contentList: [],
    }
  },
  mounted() {
    this.getMeetings()
  },
  methods: {
    back() {
      this.$router.back()
    },
    tabChange(val) {
      if (val) {
        this.search.tag = JSON.parse(val).join(',')
      } else {
        this.search.tag = null
      }
      this.getMeetings()
    },
    siftingChange(val) {
      switch (val.type) {
        case 1:
          this.search.sort = val.value
          this.getMeetings()
          break
        case 2:
          this.search.label2 = val.value === '亚专业' ? null : val.value
          this.getMeetings()
          break
        case 3:
          this.search.label3 = val.value === '检查类型' ? null : val.value
          this.getMeetings()
          break
      }
    },
    searchTitle(val) {
      this.search.title = val
      this.getMeetings()
    },
    getMeetings() {
      this.searchEmpty = true
      let params = {
        pageSize: 200,
        pageNum: 1,
        params: {
          catalog2: this.$route.params.catalog || null,
          type: this.activityType,
          title: this.search.title || null,
          tag: this.search.tag || null,
          sort: this.search.sort || null,
          label2: this.search.label2 || null,
          label3: this.search.label3 || null,
        }
      }
      this.$http.post(this.$api.activity.list, params).then(res => {
        let {code, data} = res
        if (code === 0) {
          this.contentList = data.content
          wxShare(data.content[0].catalog1, data.content[0].title, data.content[0].image)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.case-box {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 25px;
  background: #FFFFFF;
}
</style>
